/* eslint-disable react/self-closing-comp */
import clsx from 'clsx'
import { FC, useEffect, useRef } from 'react'
import { BasicStyledComponent } from 'shared-definitions/types'

interface ViafouraConversationsProps extends BasicStyledComponent {
  containerId: string
}

const ViafouraConversations: FC<ViafouraConversationsProps> = ({ className, containerId }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      const el = document.createElement('vf-conversations')
      el.setAttribute('vf-container-id', containerId)
      el.setAttribute('initial-height', '440')
      ref.current.appendChild(el)
      void window.vf?.context.resetWidget(el)
    }

    return () => {
      if (ref.current) {
        ref.current.innerHTML = ''
      }
    }
  }, [containerId])

  return <div className={clsx('viafoura', className)} ref={ref} />
}

export default ViafouraConversations
